import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceLineItem } from "@common/types/invoice";
import { useEntitiesById } from "@hooks/useEntities";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import styles from "./EntityCell.module.scss";

export const EntityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => {
        const entitiesById = useEntitiesById();
        const entityId = row.original.invoice?.entityId;
        const entity =
            entityId !== undefined ? entitiesById.get(entityId) : undefined;

        return (
            <ViewTableCell className={styles.entityCell}>
                {entity && (
                    <AvatarTooltip content={entity.name}>
                        <EntityAvatar
                            size="xs"
                            entity={entity}
                            copyId={entity.id}
                        />
                    </AvatarTooltip>
                )}
            </ViewTableCell>
        );
    },
);
